/* NLC — open/close hooks for the cart drawer.

   Lives outside the section on purpose: cart.js replaces the innerHTML of
   #CartDrawer-<id> on every cart update, which destroys the close button
   and any listener bound to it at startup. Delegating from document
   survives those re-renders.

   THE FALLBACK PROBLEM
   Several NLC sections (the Complete the Look buying guide, the reviews
   "Shop this look" button) end their add-to-cart with roughly:

     if (window.nlcOpenCart) { window.nlcOpenCart(); }
     else { document.querySelector('[data-cart-toggle],[aria-controls="CartDrawer"]').click(); }

   That fallback is unreliable against this drawer, because the FIRST
   element matching [aria-controls="CartDrawer"] is the drawer's own
   .fixed-overlay — the CLOSE target. So a section that adds to cart ends
   up closing the drawer instead of opening it.

   Two defences below:
     1. define nlcOpenCart, so sections take the first branch; and
     2. guard the overlay — if something clicks it while the drawer is
        shut, treat that as "open" rather than "close". A real customer
        can never click an overlay that isn't visible, so this only ever
        affects programmatic clicks from the fallback path.

   'cart:refresh' is handled by CartDrawer.onCartRefresh in cart.js: it
   re-fetches the section, swaps the drawer's innerHTML, and calls show()
   when detail.open is true. Requires FoxTheme.routes.root_url, set in
   js-variables.liquid. */
(function () {
  function getDrawer() {
    return document.getElementById('CartDrawer');
  }

  function isOpen() {
    var d = getDrawer();
    if (!d) return false;
    return !d.hasAttribute('hidden') || d.hasAttribute('open') || d.classList.contains('is-open');
  }

  window.nlcOpenCart = function () {
    document.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
    );
  };

  window.nlcCloseCart = function () {
    var drawer = getDrawer();
    if (!drawer) return;
    if (typeof drawer.hide === 'function') { drawer.hide(); return; }
    if (typeof drawer.close === 'function') { drawer.close(); return; }
    drawer.removeAttribute('open');
    drawer.setAttribute('hidden', '');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* close button / continue shopping — survives drawer re-renders */
    if (e.target.closest('.nlc-cd__close, .nlc-cd__continue')) {
      e.preventDefault();
      e.stopPropagation();
      window.nlcCloseCart();
      return;
    }

    /* overlay clicked while the drawer is shut = a section trying to open it */
    var overlay = e.target.closest('#CartDrawer .fixed-overlay');
    if (overlay && !isOpen()) {
      e.preventDefault();
      e.stopPropagation();
      window.nlcOpenCart();
    }
  }, true);
})();
